import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import componentStyles from './text-nav.css.lit.ts';
import QueryComponent from '../../base/query-component/QueryComponent.js';
import {isExternalUrl, leavingSiteAlertHandler, externalLinkHoverText, renderIcon} from "../../utils/link";

export default class TextNav extends QueryComponent {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      links: { type: Array },
      forceWrap: { type: Boolean },
      navClass: { type: String },
      title: { type: String },
      maxHeight: { type: Number },
      isHPSite: { type: Boolean },
      ignoreExternalUrl: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.forceWrap = false;
    this.maxHeight = null;
    this.isHPSite = false;
    this.ignoreExternalUrl = false;
  }

  onClick(event) {
    if (isExternalUrl(event.target.getAttribute('href')) && !this.ignoreExternalUrl && !leavingSiteAlertHandler()) {
      event.preventDefault()
    }
  }

  async updated() {
    if (this.forceWrap) {
      const children = this.shadowRoot.querySelectorAll('*');
      await Promise.all(Array.from(children).map(c => c.updateComplete));
      this._setContainerHeight();
    }
  }

  _setContainerHeight() {
    const element = this.shadowRoot.getElementById(
      `text-nav--${this.navClass}`
    );
    const elementHeight = element.offsetHeight;
    if (this._mediaQuery('sm', 'min')) {
      if (!this.maxHeight) {
        this.maxHeight = elementHeight;
      }
    } else {
      this.maxHeight = null;
    }
    element.style['max-height'] =
      this.maxHeight > 0 ? `${this.maxHeight - 100}px` : '';
  }

  render() {
    return html`
      <nav role="navigation" title="${this.title}">
        <ul
          id="text-nav--${this.navClass}"
          class="${classMap({
            'text-navigation': true,
            [`text-navigation--${this.navClass}`]: !!this.navClass,
            'text-navigation--hp': this.isHPSite
          })}"
        >
          ${this.links.map(link => {
            let target = '_self';
            return html`<li class="text-navigation--item">
              <a
                href=${link.url}
                @click="${this.onClick}"
                target="${target}"
                title="${ifDefined(isExternalUrl(link.url) ? externalLinkHoverText(link.text) : link.text)}"
                class="${classMap({
                  'active': !!link.active,
                  'text-navigation--link': true,
                  'link--external': this.externalUrl && !this.ignoreExternalUrl,
                })}"
              >
                ${link.text}
                ${renderIcon(link.url, this.ignoreExternalUrl)}
              </a>
              ${link.sub
                ? html`<ul
                    class="${classMap({
                      'text-sub-navigation': true,
                      [`text-sub-navigation--${this.navClass}`]:
                        !!this.navClass,
                    })}"
                  >
                    ${link.sub.map(subLink => {
                      return html`<li class="text-sub-navigation--item">
                        <a
                          href=${subLink.url}
                          @click="${this.onClick}"
                          target="_self"
                          title="${ifDefined(isExternalUrl(subLink.url) ? externalLinkHoverText(subLink.text) : subLink.text)}"
                          class="${classMap({
                            'active': !!subLink.active,
                            'text-sub-navigation--link': true,
                            'link--external': isExternalUrl(subLink.url),
                          })}"
                        >
                          ${subLink.text}
                          ${renderIcon(subLink.url, this.ignoreExternalUrl)}
                        </a>
                      </li>`;
                    })}
                  </ul> `
                : ``}
            </li>`;
          })}
        </ul>
      </nav>
    `;
  }
}

customElements.define('hf-text-nav', TextNav);
